import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { baseUrl, route } from "../../App";
import { MeissaOTOrder } from "./meissa-ot-order";
import { MeissaOTSerialNumber } from "./meissa-ot-serial-number";
import "./styles.scss";
import { MeissaOTReprint } from "./meissa-ot-reprint";
import { SidraLEGTabletFlash } from "../sidra-leg/sidra-leg-tablet-flash";

function MeissaOTHome(props: RoutableProps) {
    return <div class="orion-sit-page">
        <h1 style="text-align: center; font-size: 30px; margin-top: 10px;">Wybierz akcje</h1>
        <div class="paper action-list">
            <div class="product-list" style="margin-top: 10px;">
            <div class="action-button" onClick={() => route("/meissa-ot/tablet-flash")}>
                    <span class="icon">developer_board</span>
                    <div class="action">Zaprogramuj tablet</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/meissa-ot/serial-number")}>
                    <span class="icon">confirmation_number</span>
                    <div class="action">Wygeneruj numery seryjne</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/meissa-ot/reprint")}>
                    <span class="icon">view_agenda</span>
                    <div class="action">Wydrukuj naklejkę dla istniejącego numeru</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/meissa-ot/order")}>
                    <span class="icon">post_add</span>
                    <div class="action">Stwórz zestawienie</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/order")}>
                    <span class="icon">list_alt</span>
                    <div class="action">Pokaż zestawienia</div>
                    <span class="icon">chevron_right</span>
                </div>
            </div>
        </div>
    </div>;
}

export function MeissaOT(props: RoutableProps) {
    return <Router>
        <MeissaOTHome path={`${baseUrl}/meissa-ot`}/>
        <MeissaOTSerialNumber path={`${baseUrl}/meissa-ot/serial-number`}/>
        <MeissaOTReprint path={`${baseUrl}/meissa-ot/reprint`}/>
        <MeissaOTOrder path={`${baseUrl}/meissa-ot/order`}/>
        <SidraLEGTabletFlash path={`${baseUrl}/meissa-ot/tablet-flash`} exitDestination="/meissa-ot/serial-number" />
    </Router>
}
